import { render } from "./WineThree.vue?vue&type=template&id=02b2a124"
const script = {}

import exportComponent from "../../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/package/WineThree.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "02b2a124"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('02b2a124', __exports__)) {
    api.reload('02b2a124', __exports__)
  }
  
  module.hot.accept("./WineThree.vue?vue&type=template&id=02b2a124", () => {
    api.rerender('02b2a124', render)
  })

}


export default __exports__